export default "__VITE_ASSET__2bbf2f22__"